import { type ElementType, type JSX } from 'react';

import { formatTimeSpent, type FormatTimeSpentOptions } from '@craft/lib/durations';

import { Typography, type TypographyProps } from '../typography/Typography';

export type TrackedTimeProps<E extends ElementType = 'div'> = {
  readonly hours?: null | number;
  readonly minutes?: null | number;
  readonly options?: FormatTimeSpentOptions;
} & Omit<TypographyProps<E>, 'children'>;

export const TrackedTime = <E extends ElementType>({
  hours,
  minutes,
  options,
  ...props
}: TrackedTimeProps<E>): JSX.Element => (
  <Typography<E> component={'div' as E} {...(props as TypographyProps<E>)}>
    {formatTimeSpent({ hours: hours ?? 0, minutes: minutes ?? 0 }, options)}
  </Typography>
);
